// ---------------------------------------------------------------------------
// Project context — persists selected tenant + project across the admin app
// ---------------------------------------------------------------------------

import { createContext, useContext, useState, type ReactNode } from 'react';

interface ProjectContextValue {
  tenantId: string;
  projectId: string;
  setProject: (tenantId: string, projectId: string) => void;
}

const ProjectContext = createContext<ProjectContextValue | null>(null);

export function ProjectProvider({ children }: { children: ReactNode }) {
  const [tenantId, setTenantId] = useState(
    () => localStorage.getItem('nv_tenant_id') ?? '',
  );
  const [projectId, setProjectId] = useState(
    () => localStorage.getItem('nv_project_id') ?? '',
  );

  const setProject = (tid: string, pid: string) => {
    setTenantId(tid);
    setProjectId(pid);
    localStorage.setItem('nv_tenant_id', tid);
    localStorage.setItem('nv_project_id', pid);
  };

  return (
    <ProjectContext.Provider value={{ tenantId, projectId, setProject }}>
      {children}
    </ProjectContext.Provider>
  );
}

export function useProjectContext() {
  const ctx = useContext(ProjectContext);
  if (!ctx) {
    throw new Error('useProjectContext must be used within ProjectProvider');
  }
  return ctx;
}
